import React from 'react';
import { Card } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
// import { Container } from 'react-bootstrap';
import './Products.css';

import prodtouchlcmbg from '../images/PageImg/ProductTouchLcm-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { TdmOcaImg } from "../assets/ProductTdmData";
import { TdmOcrImg } from "../assets/ProductTdmData";
import { TdmTOcaImg } from "../assets/ProductTdmData";

import { TdmOcaTxt } from "../assets/ProductTdmData";
import { TdmOcrTxt } from "../assets/ProductTdmData";
import { TdmTOcaTxt } from "../assets/ProductTdmData";

import { GoTopBtn } from '../components/GoTopBtn';

function ProductTouchLcm() {
  // console.log("get into ProductTouchLcm()");
  return (
    <div className='products-page container-fluid'>
      <div className='productheader'
        style={{ backgroundImage: `url(${prodtouchlcmbg})`, height: "auto" }} >
        <HeaderSlide text={'Product / Touch Display'} />
        {/* <HeaderSlide text={'Product / Touch Display'} color='text-light'/> */}
        <h4 className='text-light'>&nbsp;images/PageImg/ProductTouchLcm-page-bg.jpg</h4>
      </div>
      {/* <br /> */}

      {/* Product TouchLcm OCA Direct Bonding */}
      <section id='producttdmocadb' className='product-block bg-success-subtle'>
        {/* <h2 className='title-holder fs-1 fw-bold text-success'>Product TouchLCM/ OCA DB</h2> */}
        <h1 className='title-holder fw-bold text-success'>Touch Display / OCA Optical Bonding</h1>
        {/* <Container fluid> */}
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            TdmOcaImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            // <Row> {
            TdmOcaTxt.map((tdm) => {
              return (
                <Row key={tdm.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <br />
                    <Card.Title className='text-center fs-3 text-primary'> {tdm.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text>
                    {/* <Card.Text className='fs-6' style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
            // } </Row>
          } </Col>
        </Row>
        {/* </Container> */}
      </section>

      {/* Product TouchLcm OCR Direct Bonding */}
      <section id='producttdmtocadb' className='block product-block bg-primary-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>Touch Display / OCR Optical Bonding</h2>
        <Row>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            TdmOcrTxt.map((tdm) => {
              return (
                <Row key={tdm.id} className='holder'>
                  <Card className='bg-warning-subtle border-1' style={{ marginLeft: '11px' }}>
                    <br />
                    <Card.Title className='text-center fs-3 text-success'> {tdm.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text>
                    {/* <Card.Text className='fs-4' style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
          } </Col>
          <Col lg={5} className='flex-column justify-content-center'> {
            TdmOcrImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
        </Row>
      </section>

      {/* Product TouchLcm Thich OCA Film Direct Bonding */}
      <section id='producttdmocrdb' className='product-block bg-success-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-success'>Touch Display / TOCA Optical Bonding</h2>
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            TdmTOcaImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} className='img-fluid' style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            TdmTOcaTxt.map((tdm) => {
              return (
                <Row key={tdm.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  {/* <Row key={tdm.id} className='holder' style={{ marginLeft: '-25px' }}> */}
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <br />
                    <Card.Title className='text-center fs-3 text-primary'> {tdm.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {tdm.text} </Card.Text>
                  </Card>
                </Row>
              )
            })
          } </Col>
        </Row>
        {/* </Container> */}
      </section>
      
      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default ProductTouchLcm;

// import { TdmTopImg } from "../assets/ProductTdmData";

/* Product TouchLcm Top Image */
/*
<section id='producttdmtop' className='block product-block bg-primary-subtle'> {
  <Row className='d-flex justify-content-around'> {
    TdmTopImg.map(idx => {
      return (
        <Col lg={4} key={idx.id} className='flex'>
          <img src={idx.image} style={{ height: '45vh' }} className='img-fluid' alt='' />
          <h5 className='text-warning-emphasis'>{idx.alt}</h5>
        </Col>
      )
    })
  } </Row>
} </section>
*/
